module.exports = __webpack_public_path__ + "img/growthAbility7.31e964c6.png";